import { List } from 'antd'

const GroupedListItem: React.FC = ({ children }) => (
  <List.Item style={{ display: 'block' }}>{children}</List.Item>
)

export default GroupedListItem
